import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as constants from '../../constant'

@Component({
  selector: 'wl-landing1',
  templateUrl: './landing1.component.html',
  styles: [],
})
export class Landing1Component implements OnInit {
  isCoLogin: boolean;
  roleId: string;
  text: string;
  showButtons: boolean;
  showDropDown: boolean;

  constructor(private route: Router) {}

  ngOnInit() {
    this.roleId = sessionStorage.getItem('getroleId');
    this.isCoLogin = false;
    if (this.roleId == '1') {
      this.isCoLogin = true;
    }

    // Only the roles that arrive without a state of their own are asked to pick
    // one. 11 and 12 are not among them: login already stored their state from
    // the staff record, so they go straight to Fresh / Renewal like every other
    // role that comes in with one.
    if (
      this.roleId == '7' ||
      this.roleId == '8' ||
      this.roleId == '0'
    ) {
      this.showButtons = false;
      this.showDropDown = true;
      this.text = 'Please select a state';
    } else {
      this.showDropDown = false;
      this.text = !this.isCoLogin ? 'Please select an option' : '';
      this.showButtons = true;
    }
  }

  selectState(value) {
    console.log(value);
    this.showButtons = true;
    if (value == 'MP') {
      sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.MP.KEY);
    } else if (value == 'KA') {
      sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.KA.KEY);
    } else if (value == 'AD') {
      sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.AD.KEY);
    } else if (value == 'RJ') {
      sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.RJ.KEY);
    } else if (value == 'GJ') {
      sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.GJ.KEY);
    } else if (value == 'MH') {
      sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.MH.KEY);
    }
  }

  onfresh() {
    sessionStorage.setItem('first-page', 'true');
    sessionStorage.setItem('fresh-page', 'true');
    this.route.navigate(['/fresh-app/view-summary']);
    sessionStorage.removeItem('renew-page');
  }

  renewal() {
    sessionStorage.setItem('first-page', 'true');
    sessionStorage.setItem('renew-page', 'true');
    this.route.navigate(['/admin/view-dashboard']);
    sessionStorage.removeItem('fresh-page');
  }

  onUtilities() {
    sessionStorage.setItem(constants.ROUTE_KEY, constants.STATES.KA.KEY);
    sessionStorage.setItem('renew-page', 'true');
    this.route.navigate(['/admin/utilities']);
    sessionStorage.removeItem('fresh-page');
  }

  onSof() {
    // sessionStorage.setItem('wEnlw3OeU3', 'KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y');
    // sessionStorage.setItem('renew-page', 'true');
    this.route.navigate(['/admin/sof']);
    // sessionStorage.removeItem('fresh-page');
  }

  haveSofUpdateAccess() {
    const accessList = [3];
    if (accessList.includes(+this.roleId)) {
      return true;
    }
    return false;
  }
}
